<script setup lang="ts">
import type { NuxtError } from "#app";

const props = defineProps({
  error: Object as () => NuxtError,
});

const handleError = () => clearError({ redirect: "/" });
</script>

<template>
  <div class="flex flex-col items-center gap-4 h-screen justify-center">
    <img
      src="~assets/images/logos/pokergo-logo.png"
      class="w-72 lg:w-96 cursor-pointer"
      alt="pokergo-logo"
    />

    <div class="text-xl lg:text-5xl font-bold">Something went wrong !</div>
    <h2>{{ error?.statusCode }} : {{ error?.message }}</h2>
    <h2></h2>
    <Button @click="handleError">Go back</Button>
  </div>
</template>

<style scoped></style>
